// Unmute video and replay it from the begining
export default function useUnumuteVideo () {
    const video = document.querySelector( ".contactUsIntro-video" )
    const unmuteButton = document.querySelector( ".contactUsIntro-button" )

    unmuteButton.addEventListener( "click", handleUnmuteClick )

    function handleUnmuteClick () {
        video.loop = false
        video.currentTime = 0
        video.muted = false
        video.controls = true

        unmuteButton.remove()
    }
}
